import GoogleMap from './google-map'
import { LocationType as _LocationType, GoogleAPI as _Test } from './google-map'

export type LocationType = _LocationType

export const GoogleAPI = _Test

export default GoogleMap
